(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_before-after-slider"] && !Shopify.designMode) return;
  try {
    class BeforeAfterSlider extends HTMLElement {
    connectedCallback() {
      const slider = this.querySelector('.ba-slider');
      const before = this.querySelector('.ba-before');
      const handle = this.querySelector('.ba-handle');

      if (!slider || !before || !handle) return;

      const updateSlider = (value) => {
        const rightClip = 100 - value;
        before.style.clipPath = `inset(0 ${rightClip}% 0 0)`;
        handle.style.left = value + '%';
      };

      // Initialize slider position
      updateSlider(slider.value);

      slider.addEventListener('input', function() {
        updateSlider(slider.value);
      });
    }
  }

  if (!customElements.get('before-after-slider')) {
    customElements.define('before-after-slider', BeforeAfterSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["maiorino-reviews"] && !Shopify.designMode) return;
  try {
    (function() {
  const wrapper = document.querySelector('.reviews-wrapper');
  if (!wrapper) return;

  const slidesContainer = wrapper.querySelector('slideshow-slides');
  const container = wrapper.querySelector('slideshow-container');
  if (!slidesContainer || !container) return;

  const slides = slidesContainer.querySelectorAll('.reviews-slide');
  if (!slides.length) return;

  function updateHeight() {
    const containerRect = slidesContainer.getBoundingClientRect();
    const containerCenter = containerRect.left + containerRect.width / 2;

    let activeSlide = slides[0];
    let minDistance = Infinity;

    slides.forEach(slide => {
      const slideRect = slide.getBoundingClientRect();
      const slideCenter = slideRect.left + slideRect.width / 2;
      const distance = Math.abs(slideCenter - containerCenter);

      if (distance < minDistance) {
        minDistance = distance;
        activeSlide = slide;
      }
    });

    const reviewItem = activeSlide.querySelector('.review-item');
    if (reviewItem) {
      container.style.height = reviewItem.offsetHeight + 'px';
    }
  }

  updateHeight();
  slidesContainer.addEventListener('scroll', updateHeight, { passive: true });
  window.addEventListener('resize', updateHeight, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

})();
